// src/pages/HomePage.js
import React from 'react';
import { useAtom } from 'jotai';
import { currentUserAtom } from '../auth/AuthAtoms';
import LandingPage from './home/LandingPage';
import DashboardPage from './home/DashboardPage';

const HomePage = () => {
    const [currentUser] = useAtom(currentUserAtom);

    if (currentUser) {
        return <DashboardPage userID={currentUser.userID} />;
    }

    return <LandingPage />;
};

export default HomePage;
